import { createAction, props } from '@ngrx/store';
import { AuthenticationResult } from '@qvs/core';

export const cancelAuthentication = createAction('[Auth] Cancel Authentication');

export const createAuthenticationSuccess = createAction(
  '[Auth] Create Authentication success',
  props<{ authenticationResult: AuthenticationResult; contractNumber?: string; authenticatedAt?: number }>()
);

export const createAuthenticationFromAccessAppSuccess = createAction('[Auth] Create Authentication From Access App Success');

export const createAuthenticationResultSuccess = createAction(
  '[Auth] Create Authentication Result Success',
  props<{ authenticationResult: AuthenticationResult }>()
);

export const authenticateByContractNumber = createAction(
  '[Auth] Authenticate by contract number',
  props<{ contractNumber: string; contractNumberPrefixed: string }>()
);

export const authenticateByContractNumberFailure = createAction(
  '[Auth] Authenticate by contract number failure',
  props<{ authenticationResult: AuthenticationResult; error?: any }>()
);

export const authenticateByUserNamePassword = createAction(
  '[Auth] Authenticate by username / password',
  props<{ username: string; password: string; usernamePrefixed: string }>()
);

export const authenticateByUserNamePasswordFailure = createAction('[Auth] Authenticate by username / password failure');

export const redirectedAfterAuthenticationSuccess = createAction('[Auth] Redirect After Authentication Success');

export const redirectedAfterAuthentication = createAction('[Auth] Redirect After Authentication');

export const acceptConsent = createAction('[Auth] Accept Consent');

export const cancelConsent = createAction('[Auth] Cancel Consent');

export const acceptConsentSuccess = createAction('[Auth] Accept Consent Success');

export const logout = createAction('[Auth] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');

export const logoutFailure = createAction('[Auth] Logout Failure');

export const accessAppIsUnavailable = createAction('[Auth] Access App Is Unavailable');
